<div
	class="content"
	matTooltip="{{ errorText }}"
	matTooltipClass="pv-tooltip"
	matTooltipPosition="below"
	[formGroup]="form"
	[matTooltipDisabled]="!error"
>
	<div class="ic-block">
		<input
			formControlName="hours"
			min="0"
			placeholder="."
			type="number2"
			[class]="inputClass"
			(blur)="onBlurred()"
			(input)="onChange()"
		/>
		<p>{{ "labels.time.hours" | translate }}</p>
	</div>
	<div class="ic-block">
		<input
			formControlName="minutes"
			min="0"
			placeholder="."
			type="number2"
			[class]="inputClass"
			(blur)="onBlurred()"
			(input)="onChange()"
		/>
		<p>{{ "labels.time.minutes" | translate }}</p>
	</div>
</div>
